import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function warehouseRate() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            active: true
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`warehouse-tariff/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`warehouse-tariff/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('warehouse-tariff/create', data);
    }

    function update(data) {
        return axiosInstance.patch('warehouse-tariff/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`warehouse-tariff/delete`, {
            data: {
                id: id
            }
        });
    }
}
